var React = require('react');

function Leaf32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M26.66 19.673c-3.221 3.424-7.691 5.16-13.286 5.16h-.002c-2.445-.001-5.145-.35-8.019-1.016-2.983 4.268-3.357 7.025-3.364 7.082a1.001 1.001 0 0 1-1.111.878.997.997 0 0 1-.89-1.097c.03-.265.468-3.562 4.029-8.475-.076-2.389.046-11.211 5.527-17.038C14.263.151 21.683-1.232 31.398 1.14a1 1 0 0 1 .762.891c.033.446.754 10.996-5.5 17.642zm3.519-16.778C21.594.95 15.104 2.179 11.02 6.518c-3.717 3.951-4.693 9.618-4.926 13.081 2.128-2.46 4.987-5.201 8.846-8.098V7.22c0-.549.592-1.256 1.149-1.256.556 0 .851.707.851 1.256v2.836c2.767-1.942 5.974-3.94 9.714-5.957a1.011 1.011 0 0 1 1.366.395.986.986 0 0 1-.4 1.347c-4.244 2.289-7.775 4.546-10.734 6.715-.075.19-.229.286-.454.329a66.969 66.969 0 0 0-2.964 2.335h8.472c.556 0 1.195.125 1.195.674s-.639 1.326-1.195 1.326H11.2c-1.863 1.732-3.35 3.361-4.539 4.852 2.403.506 4.66.774 6.712.775h.001c5.013 0 8.986-1.522 11.811-4.525 4.781-5.081 5.035-13.017 4.994-15.427z","key":1})]);
}

Leaf32px.displayName = "Leaf32px";

Leaf32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32.19 31.78"};

module.exports = Leaf32px;

Leaf32px.default = Leaf32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/leaf-32px.svg
// module id = 1105
// module chunks = 0